<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="/patient-register"><i class="fa fa-plus-square"></i></a>&nbsp;Patients <span class="badge bgbadge">{{ filteredPatients.length }}</span> <div v-if="search" class="fst-italic fs-6">Résultats pour <span class="bg-warning text-lowercase font-monospace ">{{ search }}</span></div></h3><br>
                            <div class="table-responsive">
                                <template v-if="filteredPatients.length>0">
                                    <div class="table-wrapper">
                                        <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Code Dossier</th>
                                                <th>Patients</th>
                                                <th>Téléphone</th>
                                                <!-- <th>Adresse</th>
                                                <th>Inscription</th> -->
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(patient,key) in filteredPatients" :key="key">
                                                <td><router-link :to="{ name: 'consultation-dossier', params: { dossier: patient.code_dossier } }" title="Consulter Dossier Patient" @click="redirectTo(`/consultation-dossier/${patient.code_dossier}`);">{{patient.code_dossier}}</router-link></td>                                               
                                                <td>{{patient.nom}} {{patient.prenom}}</td>
                                                <!-- <td>{{user.prenom_user}}</td> -->
                                                <td>{{patient.phone}}</td>                                               
                                                <!-- <td>{{ patient.sexe === 1 ? 'Masculin' : 'Feminin' }}</td> -->
                                                <!-- <td>{{ formatDate(user.date_creation)}}</td> -->
                                                <td>
                                                    <a href="#" class="text-inverse mx-3" @click="getInfoPatient(patient.patient_code)"  title="Details" data-bs-toggle="modal" data-bs-target="#voirdetails"><i class="fa fa-eye "></i></a>&nbsp;&nbsp;
                                                    <a href="#" class="text-inverse mx-3" @click="editInfoPatient(patient.patient_code)" title="Edit" data-bs-toggle="modal" data-bs-target="#myModalUpdatePatient"><i class="fa fa-edit"></i></a>&nbsp;&nbsp;
                                                    <a href="#" v-if="patient.declasser==0" class="text-inverse mx-3" @click="declassementDossier(patient.patient_code)" title="Déclasser Dossier" data-bs-toggle="modal" data-bs-target="#myModalDeclassementDossier"><i class="fas fa-folder-open"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
    
    <!-- START All Modal -->
        <!--Begin voirdetails -->
        <div class="modal" id="voirdetails">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 class="modal-title text-center" id="exampleModalLabel">Détails Patient</h5>
                        <button type="button" id="closeVoirDetailsUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                       <template v-if="info_patient?.patient_phone">
                        <div class="col-lg-12 text-center">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Numéro Dossier</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.code_dossier }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Nom</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_nom }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Prénom</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_prenom }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                            <p class="mb-0">Téléphone</p>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_phone }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Sexe</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{info_patient.patient_sexe === 1 ? 'Masculin' : 'Féminin' }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Date Naissance</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_date_naiss.split('-').reverse().join('-') }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Lieu Naissance</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_lieu_naiss }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Adresse</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_adresse }}</p>
                                        </div>
                                    </div>                                    
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Commune</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_commune }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Département</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_departement }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Profession</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_profession }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Travail</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_travail }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Personne Réf.</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_personne_reference }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Téléphone Réf.</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_patient.patient_telf_reference }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div v-if="info_patient.nom_assureur">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <p class="mb-0">Assureur</p>
                                            </div>
                                            <div class="col-sm-8">
                                                <p class="text-muted mb-0">{{ info_patient.nom_assureur }} {{ info_patient.prenom_assureur }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <p class="mb-0">Assurance</p>
                                            </div>
                                            <div class="col-sm-8">
                                                <p class="text-muted mb-0">{{ info_patient.assurance_assureur }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Date création</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ formatDate(info_patient.date_creation) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </template>
                       <template v-else>
                        <div class="modal-preloader">
                            <div class="spinner"></div>
                        </div>
                    </template>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" id="closeModalou" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>

                    </div>
                </div>
            </div>
        <!--End voirdetails -->

        <!-- Start Modal Update Patient -->
            <!-- The Modal Update Patient-->
            <div class="modal" id="myModalUpdatePatient">
                <div class="modal-dialog">
                    <div class="modal-content">             
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modifié Patient</h5>
                            <button type="button" id="closeModifierUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                            <template v-if="editPatient?.patient_phone">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <div class="row" v-if="validationErrors.length>0">
                                                <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                    <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                        <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Nom</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.nom" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Prénom</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.prenom" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Lieu Naissance</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.lieu_naissance" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Date Naissance</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="date" v-model="form_update.date_naissance" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Téléphone</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.phone" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Adresse</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.adresse" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Profession</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.profession" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Travail</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.travail" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Personne Réf.</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.personne_reference" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Téléphone Réf.</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.telf_reference" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <!-- <p class="text-center">Loading...</p> -->
                                <div class="modal-preloader">
                                    <div class="spinner"></div>
                                </div>
                            </template>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer d-flex justify-content-between">
                            <button type="button" :disabled="form_update.nom =='' || form_update.prenom=='' || form_update.email=='' || form_update.phone==''" class="btn float-left" style="background-color: #00C853; color: #fff;" @click="updatePatient">Enrégistrer</button>
                            <button type="button" id="closeModalUpdated" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        <!-- End Modal Update Patient -->

        <!-- Start Declassement Dossier -->
        <!-- The Modal -->
        <div class="modal" id="myModalDeclassementDossier">
            <div class="modal-dialog modal-md">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Déclassement Dossier</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="row" v-if="validationErrors.length>0">
                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                </ul>
                            </div>
                        </div>
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <template v-if="declasserPatient?.patient_phone">
                            <span v-if="prixTotal"> 
                                <div class="alert alert-info text-center">
                                    Frais {{ Number(prixTotal).toLocaleString('fr-FR') }} Gourdes <button @click="payment" class="btn btn-outline-dark btn-rounded ml-2">&nbsp;&nbsp;Payer</button>
                                </div>
                            </span>
                            <form @submit.prevent="registerDeclassement" ref="fdeclasser">
                                <div class="col-lg-12 text-center">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Numéro Dossier</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <p class="text-muted mb-0">{{ declasserPatient.code_dossier }}</p>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Patient</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <p class="text-muted mb-0">{{ declasserPatient.patient_nom }} {{ declasserPatient.patient_prenom }}</p>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Services</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <select class="form-control custom-select text-center" v-model="form_declasser.service" required @change="onchangeService">
                                                        <option value="">--Services--</option>
                                                        <template v-if="services.length > 0">
                                                        <option v-for="(service,key) in services" :key="key" :value="service.id">{{ service.service }}</option>
                                                        </template>
                                                        <template v-else>
                                                        <option value="">Aucun Service trouvé</option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p for="specialite" class="mb-0">Spécialiste</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <select class="form-control text-center" v-model="form_declasser.specialite" required @change="handleSpecialiteChange">
                                                        <option value="">--Spécialité--</option>
                                                        <template v-if="specialites.length > 0">
                                                        <option v-for="(specialite,key) in specialites" :key="key" :value="specialite.id">{{specialite.specialite }}</option>
                                                        </template>
                                                        <template v-else>
                                                        <option value="">Aucune Spécialité</option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Docteur</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <select class="form-control custom-select text-center" id="commune_patient" v-model = "form_declasser.doctor" @change="onchangeDocteur">
                                                        <option value="">--Docteurs--</option>
                                                        <template v-if="docteurs.length > 0">
                                                        <option v-for="(docteur,key) in docteurs" :key="key" :value="docteur.id">{{ docteur.nom }} {{ docteur.prenom}}</option>
                                                        </template>
                                                        <template v-else>
                                                        <option value="">Aucun Docteur trouvé</option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row pt-2 pb-2">
                                                <div class="pt-2">
                                                    <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;">Enrégistrer</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>                            
                       </template>
                       <template v-else>
                        <div class="modal-preloader">
                            <div class="spinner"></div>
                        </div>
                       </template>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>

                </div>
            </div>
        </div>
        <!-- End  Declassement Dossier -->
</template>
<script>
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import $ from 'jquery';
import axios from 'axios'
// import FactureForPrint from './FactureForPrint.vue';
const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
    name:"PatientAll",
    components:{
        DashView,
    },
    data(){
        return{          
          patients:[],
           donnee: JSON.parse(localStorage.getItem('donnee')) || {},
          selectedSpecialite:'',
          docteurs:[],
          services:[],
          prixService:0,
          prixSpecialite:0,
          prixDocteur:0,
          service_declasser:[],
          specialites:[],
          passwordReset:'',
          info_patient:[],
          editPatient:[],
          declasserPatient:[],
          form_update:{
            nom:'',
            prenom:'',
            phone:'',
            lieu_naissance:'',
            date_naissance:'',
            patient:'',
            adresse:'',
            profession:'',
            personne_reference:'',
            telf_reference:'',
            travail:''
          },
          form_declasser:{
            specialite:'',
            doctor:'',
            service:''
          },
          idDeclasser:'',
          success_msg:'',
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
        }
    },
    created(){
        // console.log(this.donnee);
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        axios.get(`${base_url}/getPatients`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                  if(response.status==200){
                    console.log(response.data);
                      this.patients = response.data;
                      localStorage.removeItem('donnees');
                  }                
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                // console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
                  console.error(error);
              });
    },
    methods:{
        formatDate(dateString) {
              const date = new Date(dateString);
              const day = ('0' + date.getDate()).slice(-2);
              const month = ('0' + (date.getMonth() + 1)).slice(-2);
              const year = date.getFullYear();
              const hours = ('0' + date.getHours()).slice(-2);
              const minutes = ('0' + date.getMinutes()).slice(-2);
              const seconds = ('0' + date.getSeconds()).slice(-2);
  
              return `${day}-${month}-${year}`;
        },
        onSelectsChange() {
            
            console.log('Change data');
            this.form_declasser.specialist = this.selectedSpecialite;
            // console.log('Spécialité sélectionnée:', this.selectedSpecialite);
        },
        onchangeService(){
             const serviceId = this.form_declasser.service;
             const selectedService = this.services.find(s => s.id == serviceId);
             if (selectedService) {
                this.prixService = selectedService.prix;
            }
        },
        handleSpecialiteChange() {
            this.getDoctorforSpecialite();
            this.onchangeSpecialite();
        },
        onchangeSpecialite() {
            const specialiteId = this.form_declasser.specialite;
            const serviceId = this.form_declasser.service;

            // Trouver la spécialité qui a l'id demandé
            const selectedSpecialite = this.specialites.find(s => s.id == specialiteId);

            // console.log('onchangeSpecialite');
            // console.log(selectedSpecialite);

            if (selectedSpecialite) {
                // Trouver dans les services de cette spécialité celui qui correspond au service sélectionné
                const service = selectedSpecialite.services.find(s => s.service_id == serviceId);

                if (service) {
                    this.prixSpecialite = service.prix;
                } 
                else {
                    this.prixSpecialite = 0; // Valeur par défaut si pas trouvé
                }
            } else {
                this.prixSpecialite = 0; // Valeur par défaut si spécialité pas trouvée
            }
        },
        onchangeDocteur() {
            const specialiteId = this.form_declasser.specialite;
            const docteurId = this.form_declasser.doctor;
            const serviceId = this.form_declasser.service;
            // console.log(docteurId);
            

            const selectedDocteur = this.docteurs.find(d => d.id == docteurId);

            if (selectedDocteur) {
                const serviceTrouve = selectedDocteur.services.find(s =>
                    s.specialite_id == specialiteId && s.service_id == serviceId
                );

                if (serviceTrouve) {
                    this.prixDocteur = Number(serviceTrouve.prix);
                } else {
                    this.prixDocteur = 0;
                }
            } else {
                this.prixDocteur = 0;
            }
        },
        getInfoPatient(code){
                console.log(code);
                // return false;
                this.info_patient=[];
                axios.get(`${base_url}/infoPatient?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    this.updateModalContent(response.data);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeVoirDetailsUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        updateModalContent(donnee){
            console.log('ok modal content');
            this.info_patient=donnee;
            console.log(this.info_patient);
        },
        updateModalEdit(donnee){
            console.log('Modal Update');
            // console.log(donnee);
            this.editPatient=donnee;
            this.form_update.nom=this.editPatient.patient_nom;
            this.form_update.prenom=this.editPatient.patient_prenom;
            this.form_update.lieu_naissance = this.editPatient.patient_lieu_naiss;
            this.form_update.date_naissance = this.editPatient.patient_date_naiss;
            this.form_update.phone=this.editPatient.patient_phone;
            this.form_update.adresse=this.editPatient.patient_adresse;
            this.form_update.profession=this.editPatient.patient_profession;
            this.form_update.personne_reference=this.editPatient.patient_personne_reference;
            this.form_update.telf_reference=this.editPatient.patient_telf_reference;
            this.form_update.travail=this.editPatient.patient_travail;
            this.form_update.patient=this.editPatient.patient_code;
        },
        updateModalDeclassement(donnee){
            this.declasserPatient=donnee;
        },
        editInfoPatient(code){
                this.editPatient=[];
                axios.get(`${base_url}/infoPatient?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Edit');
                    console.log(response.data);
                    this.updateModalEdit(response.data);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#closeModifierUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        declassementDossier(code){
                this.declasserPatient=[];
                this.form_declasser.doctor='';
                this.form_declasser.service='';
                this.docteurs=[];
                this.form_declasser.specialite='';
                axios.get(`${base_url}/infoPatient?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Declassement');
                    // console.log(response.data);
                    this.updateModalDeclassement(response.data);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#closeModifierUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        updatePatient(){
            console.log('Update');
            this.success_msg='';
            const control = !!(this.form_update.nom && this.form_update.prenom && this.form_update.adresse && this.form_update.phone);
            console.log(control);
            if(control){
                    const $data ={
                        id:this.form_update.patient,
                        nom : this.form_update.nom,
                        prenom : this.form_update.prenom,
                        adresse : this.form_update.adresse,
                        phone: this.form_update.phone,
                        lieu_naissance:this.form_update.lieu_naissance,
                        date_naissance:this.form_update.date_naissance,
                        profession:this.form_update.profession,
                        personne_reference:this.form_update.personne_reference,
                        telf_reference:this.form_update.telf_reference,
                        travail:this.form_update.travail
                    };
                // console.log($data);
                axios.put(`${base_url}/updatePatient`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==200|| response.status==201){
                        this.success_msg = `Patient modifié avec success!`;
                        let self = this;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalUpdated').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        getSpecialites(){
            axios.get(`${base_url}/specialites`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Specialites');
                    
                    // console.log(response?.data);
                    if(response?.status==200){
                        // console.log(response?.data);
                        if(response?.data?.length>0){

                            this.specialites = response.data;
                        }
                        // console.log(this.roles);
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
        },
        getDoctorforSpecialite(){
            console.log(this.form_declasser.specialite);
            
            this.form_declasser.doctor='';
            this.docteurs=[];
            if(this.form_declasser.specialite){
                axios.get(`${base_url}/getDoctors?specialite=${this.form_declasser.specialite}`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('getDoctorforSpecialite');
                        
                        // console.log(response?.data.docteurs);
                        this.docteurs = response?.data.docteurs;               
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
            }
        },
        getServices(){
                axios.get(`${base_url}/services`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('Services');
                        
                        console.log(response?.data);
                        if(response?.status==200){
                            // console.log(response?.data);
                            if(response?.data?.services?.length>0){
                                this.services = response.data.services;
                                // this.service_declasser = response.data.filter(element=>element.typ==0)[0];
                            }
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
        },
        getSpecialistForService(){
            // this.specialites=[];
            // this.specialites = this.services.filter(element=>element.id==this.form_declasser.service)[0]?.specialites;
        },
        initializeSelect2() {
            $(this.$refs.selects).select2();
            $('.select2').select2();
            $(this.$refs.selects).on('change', this.onSelectsChange);
        },
        registerDeclassement(){
            console.log('Form Declasser');
            this.success_msg='';
            const control = !!(this.declasserPatient.code_dossier && this.form_declasser.service && this.form_declasser.specialite);
            if(control){
                const $data = {
                    dossier: this.declasserPatient.code_dossier,
                    service : this.form_declasser.service,
                    service_name: this.services.filter(element=>element.id==this.form_declasser.service)[0].service,
                    specialite:this.form_declasser.specialite,
                    docteur: this.form_declasser.doctor
                };
                // console.log($data);


                axios.post(`${base_url}/declasser_dossier`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Dossier déclassé avec success!`;
                        // setTimeout(function() {
                        //     location.reload();
                        // },2000);
                        
                       const donnee={
                            patient:this.info_patient,
                            details:{
                                service: this.services.filter(element=>element.id==this.form_declasser.service)[0].service,

                            }
                        }
                        this.payment(response.data.id);
                        // this.$router.push({name:"payer-facture",params:{donnee:donnee}})
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        payment(code) {
                    
        // Création de l'objet donnee
        const donnee = {
            service: this.services.find(
            element => element.id == this.form_declasser.service) || [],
            specialite: this.specialites.find(
            element => element.id == this.form_declasser.specialite) || [],
            patient: this.patients.find(
            element => element.code_dossier == this.declasserPatient.code_dossier)?? [],
            prixTotal: this.prixTotal,
            id_declasser:code
            // data: this.data
        };

        // localStorage.removeItem('donnees');

        // Enregistrement dans localStorage
        localStorage.setItem('donnees', JSON.stringify(donnee));

        // Navigation vers la page de paiement
        // this.$router.push({
        //     name: "payer-facture"
        // });
        this.$router.push({ name: "payer-facture" }).then(() => {
            window.location.reload();
        });

}

  },
  mounted(){
        this.getSpecialites();
        this.getServices();
        this.initializeSelect2();
    },
    computed: {
        prixTotal() {
            const docteur = Number(this.prixDocteur);
        const specialite = Number(this.prixSpecialite);
        const service = Number(this.prixService);
            return docteur > 0 ? docteur : (specialite > 0 ? specialite : (service > 0 ? service : 0));
        },
        search() {
            return this.$route.query.search?.toLowerCase() || '';
        },
        filteredPatients() {
            // console.log(this.search);
            
            if (!this.search) return this.patients;
            return this.patients.filter(p => {
                return (
                p.nom?.toLowerCase().includes(this.search) ||
                p.prenom?.toLowerCase().includes(this.search) ||
                p.code_dossier?.toLowerCase().includes(this.search) ||
                p.phone?.toLowerCase().includes(this.search)
                );
            });
        }
    }
}
</script>
<style scoped>

.select2-container .select2-selection--single {
            height: auto;
            display: flex;
            align-items: center;
        }

        .select2-container--default .select2-selection--single .select2-selection__rendered {
            line-height: 1.5;
            text-align: center;
            white-space: normal;
        }

        .select2-dropdown {
            max-height: 200px; 
            overflow-y: auto;
            z-index: 9999; /* Pour que ca apparait sur le modal */
        }

        .select2-selection__arrow {
            height: 100%;
        }

</style>